// import { XMarkIcon } from '@heroicons/react/24/outline';

interface BadgeProps {
    name: any;
    className?: string;
    isCrossIcon?: boolean;
    crossHandler?: any;
    badgeStatus?: 'approved' | 'pending' | 'rejected' | 'default' | 'disabled' | 'borderbadge' | 'accepted' | 'published';
}

export default function Badge({ name, className, crossHandler, badgeStatus = 'default' }: BadgeProps) {
    const getStatus = () => {
        switch (badgeStatus) {
            case 'approved':
            case 'accepted':
                return "bg-approvedLight border-none text-approvedDark font-bold";
            case 'pending':
                return "bg-pendingLight border-none text-pendingDark font-bold";
            case 'rejected':
                return "bg-rejectLight border-none text-rejectDark font-bold";
            case 'published':
                return "bg-publishedLight border-none text-publishedDark font-bold";
            case 'disabled':
                return "!bg-transparent border-none !text-disabledDark !cursor-not-allowed";
            case 'borderbadge':
                return "p-2 mr-2 mb-2 bg-transparent  !text-labelTextCol !border-labelTextCol  !inline-flex !w-auto ";
            default:
                return "flex text-xs font-aeonikReg p-2 rounded border border-black";
        }
    };
    return (
        <div
            onClick={crossHandler}
            className={`flex text-xs justify-center font-aeonikReg p-2 rounded-basicRadius ${className} border border-black break-words ${getStatus()} `}
        >
            <span>{name}</span>
        </div>
    );
};